import React from "react";
// import SideHeader from "./Side/Header";
import Main from './Main'
import {SimpleList} from "./List";

export default class Side extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active_menu: "Profile"
    };

    this.changeMainContent = this.changeMainContent.bind(this);
  }

  changeMainContent(e) {
    this.props.changeContent(e);
  }

  render() {
      const navs = ['Profile', 'Works'];
      return (
        <div className='side'
          style={{
            backgroundColor: '#272B33' //282c34
          }}>
            <nav style={{
              alignItems: 'center',
              minHeight: '50%',
              justifyContent:'center',
              display:'flex'
              }}>
              <SimpleList list={navs}  func={(e) => { this.changeMainContent(e); }} />
            </nav>
            <div className='sidebar_decoration'></div>
        </div>
      );
    }
  }
